import SRSBranchEmployeeComponent from './SRSBranchEmployee.component';

export default SRSBranchEmployeeComponent;
